import { useUrlStateSlice } from "@/common/hooks/use-url-state-slice";
import type { DetailTab } from "@/components/detail-page/types";
import { useCallback } from "react";

interface ActiveTabState {
  activeTab: string | undefined;
  selectTab: (value: string) => void;
}

export function useActiveTab(sections: DetailTab[], stateKey: string): ActiveTabState {
  const [requestedTab, setTabSlice] = useUrlStateSlice<string>(stateKey);

  const defaultTab = sections[0]?.id;
  const activeTab = sections.some((section) => section.id === requestedTab) ? requestedTab : defaultTab;

  const selectTab = useCallback(
    (value: string) => {
      setTabSlice(value === defaultTab ? undefined : value);
    },
    [setTabSlice, defaultTab],
  );

  return { activeTab, selectTab };
}
